import React, { useMemo } from 'react';
import { i18nFn, Plan, SubscriptionPlanDTO } from '@springbig/shared';
import { H4 } from '~/shared/Typography';
import { format, isBefore } from 'date-fns';

export type PlanScheduleProps = {
    plan: Plan | SubscriptionPlanDTO;
    fontWeight?: string;
    fontSize?: number;
    t: i18nFn;
};

export const PlanSchedule = ({
    plan,
    fontWeight = '500',
    fontSize = 14,
    t,
}: PlanScheduleProps) => {

    const generateSchedule = (): string => {

        let result = '';
        if (!plan.subscription) {
            const billing = {
                both: t('subscriptions.billing.both', [plan.recurring_amount.toFixed(2), plan.yearly_recurring_amount.toFixed(2)]),
                monthly: t('subscriptions.billing.monthly', [plan.recurring_amount.toFixed(2)]),
                yearly: t('subscriptions.billing.yearly', [plan.yearly_recurring_amount.toFixed(2)]),
            };
            const trial = plan.trial_period > 0 ? t('subscriptions.free_then', [plan.trial_period]) : '';
            result = trial + billing[plan.billing_schedule];
        }
        else if (isBefore(new Date(), new Date(plan.subscription.terminated_at))) {
            const subscription = plan.subscription;
            result = t('subscriptions.active_until', [format(new Date(subscription.terminated_at), 'PPP')]);
        }
        else {
            const subscription = plan.subscription;
            result = t('subscriptions.renews_on', [format(new Date(subscription.next_charge_on), 'PPP')]);
        }

        return result;
    };

    const schedule = useMemo(() => generateSchedule(), [plan]);

    return (
        <H4
            fontWeight={fontWeight}
            fontSize={fontSize}
            textAlign={'center'}
        >
            { schedule }
        </H4>
    );
};
